import React from 'react';

import { useAudioPlayerStore } from '@atlassian/ai-audio';

import { LoadableLazy } from '@confluence/loadable';
import { type WithFlagsProps, withFlags } from '@confluence/flags/entry-points/withFlags.ts';

type FloatingAudioContainerWrapperProps = {} & WithFlagsProps;

const FloatingAudioContentLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-FloatingAudioContent" */
				'./FloatingAudioContent.tsx'
			)
		).FloatingAudioContent,
});

export const FloatingAudioContainer = withFlags(({ flags }: FloatingAudioContainerWrapperProps) => {
	const { isOpen } = useAudioPlayerStore();

	return isOpen ? <FloatingAudioContentLoadable flags={flags} /> : null;
});
